export const PARALLEL_ROUTE_DEFAULT_NULL_PATH =
  'next/dist/client/components/builtin/default-null.js'

export default function ParallelRouteDefaultNull() {
  return null
}
